/**
 * Firebase Configuration
 *
 * Configuration for Firebase services including Auth and Firestore.
 * Values from google-services.json (zemer-7f5f1 project).
 */

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import type { User } from 'firebase/auth';

// Firebase configuration from google-services.json
const firebaseConfig = {
  apiKey: 'AIzaSyDINfEqp0BYnxdclKKgy9vIMalW_z9PjRI',
  authDomain: 'zemer-7f5f1.firebaseapp.com',
  projectId: 'zemer-7f5f1',
  storageBucket: 'zemer-7f5f1.firebasestorage.app',
  messagingSenderId: '406005787060',
  appId: '1:406005787060:web:zemer-web-app', // Web app ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth
export const auth = getAuth(app);

// Google Auth Provider
const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('email');
googleProvider.addScope('profile');

/**
 * Sign in with Google popup
 */
export async function signInWithGoogle(): Promise<User> {
  const result = await signInWithPopup(auth, googleProvider);
  return result.user;
}

/**
 * Sign out the current user
 */
export async function signOutUser(): Promise<void> {
  await signOut(auth);
}

/**
 * Get the current user's ID token
 */
export async function getIdToken(forceRefresh = false): Promise<string | null> {
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken(forceRefresh);
}

/**
 * Listen to auth state changes
 */
export function onAuthStateChanged(callback: (user: User | null) => void): () => void {
  return auth.onAuthStateChanged(callback);
}

export { User };
